export default {"src":"/_next/static/media/code-snippet-2.de105c22.svg","height":84,"width":559,"blurWidth":0,"blurHeight":0};